/* =============================================================================
   ZOVA — theme.js
   Ported 1:1 from zova-homepage-v8.html (lines 1238-1507).

   Everything from the original script is preserved:
     stone texture injection · nav solid/logo-on + cart counter · mobile menu ·
     slab hero carve/gild/split scroll animation · collection category filter ·
     testimonials carousel · pointer tilt · product data + quick view ·
     category icons · newsletter form.

   Changes required by the conversion brief:
     PERF FIX (a) - the scroll handler no longer reads layout. Hero metrics are
                    measured once and refreshed only on load/resize/section:load.
     PERF FIX (b) - the slab progress is mapped DIRECTLY to scroll position.
                    The old `cur += (target-cur)*0.12` lerp is gone, so the slab
                    stops the instant the user stops scrolling (no ~0.8s trail).
     GUARDS       - every DOM lookup is guarded; the file is safe on product,
                    collection, cart, search and 404 pages.
     REAL CART    - Shopify AJAX cart (/cart.js, /cart/add.js, /cart/change.js)
                    + cart drawer controller, exposed as window.ZovaCart.
     DATA         - CATMETA / TESTI may be overridden by Liquid through
                    window.ZOVA_CATMETA / window.ZOVA_TESTIMONIALS; the quick-view
                    products in window.ZOVA_PRODUCTS (emitted by
                    sections/card-collection.liquid) are MERGED over the built-in
                    demo entries per data-id, so a card with a real Shopify
                    product shows real copy and a real variant id.

   Plain ES2017. No modules, no imports, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  /* =========================================================================
     0. helpers
     ====================================================================== */
  function $(sel, root) {
    try { return (root || document).querySelector(sel); } catch (e) { return null; }
  }
  function $$(sel, root) {
    try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
    catch (e) { return []; }
  }
  function byId(id) { return document.getElementById(id); }

  /* bindOnce(): survives Shopify section re-renders in the theme editor without
     ever stacking duplicate listeners on the same node. */
  function bindOnce(el, key, type, fn, opts) {
    if (!el) return false;
    var flag = '__zova_' + key;
    if (el[flag]) return false;
    el[flag] = true;
    el.addEventListener(type, fn, opts);
    return true;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* scroll lock shared by the quick-view modal and the cart drawer */
  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.style.overflow = 'hidden'; }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.style.overflow = ''; }

  /* =========================================================================
     1. stone texture injection  (verbatim behaviour)
     ====================================================================== */
  var STONES = {
  makrana:    {base:'#EAE7E0', layers:[['veinSoft',.28],['veinBold',.09]]},
  banswara:   {base:'#D9D3D5', layers:[['veinSoft',.34]]},
  udaipur:    {base:'#2F4A39', layers:[['veinBold',.15],['veinSoft',.12]]},
  bhainslana: {base:'#060505', layers:[], veins:true},
  mango:      {base:'#9A6B43', layers:[['woodgrain',.55],['bands',.22]]},
};
  function paintStone(el) {
    if (!el || !el.dataset) return;                                  /* GUARD */
    var s = STONES[el.dataset.stone]; if (!s || el.dataset.painted) return;
    el.dataset.painted = '1';
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'stone');
    svg.setAttribute('viewBox', '0 0 700 700');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var inner = '<rect width="700" height="700" fill="' + s.base + '"/>';
    (s.layers || []).forEach(function (l) {
      inner += '<rect width="700" height="700" filter="url(#' + l[0] + ')" opacity="' + l[1] + '"/>';
    });
    if (s.veins) inner += '<g filter="url(#veinWarp)"><use href="#bhainslanaVeins"/></g>';
    inner += '<rect width="700" height="700" filter="url(#grain)" opacity="' + (s.veins ? 0.06 : 0.04) + '"/>';
    svg.innerHTML = inner;
    if (el.prepend) el.prepend(svg); else el.insertBefore(svg, el.firstChild);
  }
  function paintAllStones(root) { $$('[data-stone]', root).forEach(paintStone); }

  /* =========================================================================
     2. money formatting
     ====================================================================== */
  function moneyFormat() {
    var f = window.ZOVA_MONEY_FORMAT;
    return (typeof f === 'string' && f) ? f : 'AED {{amount}}';
  }
  function formatMoney(cents, format) {
    var value = Number(cents);
    if (!isFinite(value)) value = 0;
    var fmt = format || moneyFormat();
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = fmt.match(placeholder);
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':                     out = num(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator':            out = num(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':out = num(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':       out = num(value, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator':out = num(value, 0, ' ', ','); break;
      case 'amount_with_space_separator':            out = num(value, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = num(value, 2, ' ', '.'); break;
      default:                                       out = num(value, 2, ',', '.');
    }
    return match ? fmt.replace(placeholder, out) : fmt + out;
  }

  /* =========================================================================
     3. cart counter + real Shopify AJAX cart + cart drawer
     ====================================================================== */
  var cart = 0;                     /* mirrors the original optimistic counter */

  /* #cartCount keeps the original "(0)" format; any other [data-cart-count]
     node gets the bare number. */
  function setCart(n) {
    cart = n;
    var main = byId('cartCount');
    if (main) main.textContent = '(' + n + ')';
    $$('[data-cart-count]').forEach(function (el) {
      if (el === main) return;
      el.textContent = String(n);
      if (el.classList) el.classList.toggle('has-items', n > 0);
    });
  }
  /* Cart problems are surfaced in the drawer's [data-cart-error] live region and
     the drawer is opened so the shopper actually sees them. The message is kept
     in cartErrorMsg so it survives the renderDrawer() that openDrawer() triggers.
     NOTE: there is deliberately no optimistic "fake" counter bump — a click that
     cannot reach /cart/add.js must never look like it succeeded. */
  var UNAVAILABLE = 'Sorry — this piece is not available to add to the cart right now.';
  var cartErrorMsg = '';
  function showCartError(msg) {
    cartErrorMsg = msg || '';
    if (drawerEl()) openDrawer();
    var note = $('[data-cart-error]');
    if (note) note.textContent = cartErrorMsg;
  }

  function cartFetch(url, body) {
    if (typeof window.fetch !== 'function') return Promise.reject(new Error('fetch unavailable'));
    var opts = {
      method: body ? 'POST' : 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || ('Cart request failed (' + r.status + ')'));
        return j;
      });
    });
  }

  function refreshCart() {
    return cartFetch('/cart.js').then(function (c) {
      setCart(c && typeof c.item_count === 'number' ? c.item_count : 0);
      renderDrawer(c);
      return c;
    }).catch(function () { return null; });   /* GUARD: never throw on a page without a storefront cart */
  }

  function addToCart(id, qty) {
    if (!id) { showCartError(UNAVAILABLE); return Promise.resolve(null); }
    return cartFetch('/cart/add.js', { id: id, quantity: qty || 1 })
      .then(function () { cartErrorMsg = ''; return refreshCart(); })
      .then(function (c) { openDrawer(); return c; })
      .catch(function (err) {
        showCartError(err && err.message ? err.message : 'Could not add to cart.');
        return null;
      });
  }

  function changeLine(key, qty) {
    return cartFetch('/cart/change.js', { id: key, quantity: qty })
      .then(function (c) {
        cartErrorMsg = '';
        setCart(c && typeof c.item_count === 'number' ? c.item_count : 0);
        renderDrawer(c);
        return c;
      })
      .catch(function () { return null; });
  }

  /* ---- drawer ------------------------------------------------------------ */
  function drawerEl() { return byId('CartDrawer') || $('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawerEl(); if (!d) return;                              /* GUARD */
    if (d.classList.contains('is-open')) return;
    if (d.hasAttribute('hidden')) { d.removeAttribute('hidden'); d.__zovaUsesHidden = true; }
    /* force a style flush so the open transition actually runs */
    void d.offsetWidth;
    d.classList.add('is-open', 'open');
    d.setAttribute('aria-hidden', 'false');
    lockScroll();
    var close = d.querySelector('[data-cart-close]');
    if (close && close.focus) { try { close.focus(); } catch (e) {} }
    refreshCart();
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;                              /* GUARD */
    if (!d.classList.contains('is-open')) return;
    d.classList.remove('is-open', 'open');
    d.setAttribute('aria-hidden', 'true');
    cartErrorMsg = '';                 /* never resurrect a stale error */
    unlockScroll();
    if (d.__zovaUsesHidden) {
      window.setTimeout(function () {
        if (!d.classList.contains('is-open')) d.setAttribute('hidden', '');
      }, 380);
    }
  }

  function renderDrawer(c) {
    var d = drawerEl(); if (!d || !c) return;                        /* GUARD */
    var body = d.querySelector('[data-cart-body]');
    var subtotal = d.querySelector('[data-cart-subtotal]');
    var checkout = d.querySelector('[data-cart-checkout]');
    var err = d.querySelector('[data-cart-error]');
    if (err) err.textContent = cartErrorMsg;

    if (body) {
      if (!c.items || !c.items.length) {
        body.innerHTML = '<div class="pg-empty"><p>Your cart is empty.</p></div>';
      } else {
        body.innerHTML = c.items.map(function (item) {
          var img = item.image
            ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title || '') + '" loading="lazy" decoding="async">'
            : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<span class="stone-tag">' + esc(item.variant_title) + '</span>' : '';
          return '' +
            '<div class="drawer-item" data-key="' + esc(item.key) + '">' +
              '<div class="canvas">' + img + '</div>' +
              '<div class="info">' +
                '<div><a class="name" href="' + esc(item.url || '#') + '">' + esc(item.product_title || item.title || '') + '</a>' + variant + '</div>' +
                '<span class="price">' + formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price) + '</span>' +
                '<div class="qty">' +
                  '<button type="button" class="qty-btn" data-cart-qty="down" aria-label="Decrease quantity">&minus;</button>' +
                  '<span class="qty-n">' + esc(item.quantity) + '</span>' +
                  '<button type="button" class="qty-btn" data-cart-qty="up" aria-label="Increase quantity">+</button>' +
                  '<button type="button" class="qty-btn" data-cart-remove aria-label="Remove item">&times;</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        }).join('');
      }
    }
    if (subtotal) subtotal.textContent = formatMoney(c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price);
    if (checkout) checkout.disabled = !(c.items && c.items.length);
  }

  /* delegated drawer controls (survive re-render) */
  bindOnce(document, 'drawerClicks', 'click', function (e) {
    var t = e.target; if (!t || !t.closest) return;                  /* GUARD */
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-cart-overlay]')) { e.preventDefault(); closeDrawer(); return; }
    var qb = t.closest('[data-cart-qty]');
    if (qb) {
      var row = qb.closest('[data-key]'); if (!row) return;   /* no row -> let a plain link navigate */
      e.preventDefault();                                     /* AJAX owns the mutation; no GET race */
      var n = parseInt((row.querySelector('.qty-n') || {}).textContent, 10);
      if (!isFinite(n)) n = 1;
      changeLine(row.getAttribute('data-key'), qb.getAttribute('data-cart-qty') === 'up' ? n + 1 : n - 1);
      return;
    }
    var rm = t.closest('[data-cart-remove]');
    if (rm) {
      var rrow = rm.closest('[data-key]'); if (!rrow) return; /* cart page link has no [data-key] -> navigate */
      e.preventDefault();                                     /* AJAX owns the mutation; no GET race */
      changeLine(rrow.getAttribute('data-key'), 0);
    }
  });

  /* [data-add] / .cart-btn — real add when a variant id is present. With no
     variant id there is nothing to add, so we say so instead of faking it. */
  bindOnce(document, 'addBtns', 'click', function (e) {
    var t = e.target; if (!t || !t.closest) return;                  /* GUARD */
    var btn = t.closest('[data-add], .cart-btn');
    if (!btn || btn.id === 'qvAdd') return;
    if (btn.closest('[data-cart-drawer]') || btn.closest('#CartDrawer')) return;

    var form = btn.form || btn.closest('form');
    var vid = btn.getAttribute('data-variant-id');
    if (!vid && form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) vid = idInput.value;
    }
    var qty = 1;
    if (form) {
      var qInput = form.querySelector('[name="quantity"]');
      if (qInput && parseInt(qInput.value, 10) > 0) qty = parseInt(qInput.value, 10);
    }
    if (vid) {
      e.preventDefault();                       /* we handle it over AJAX */
      if (btn.disabled) return;
      btn.disabled = true;
      addToCart(vid, qty).then(function () { btn.disabled = false; });
    } else {
      e.preventDefault();
      showCartError(UNAVAILABLE);               /* no variant id -> nothing to add */
    }
  });

  window.ZovaCart = {
    refresh: refreshCart,
    add: addToCart,
    open: openDrawer,
    close: closeDrawer
  };

  /* =========================================================================
     4. nav: solid on scroll + logo-on + cart button + mobile menu
     ====================================================================== */
  function initNav() {
    /* the original "open cart placeholder" now opens the real drawer */
    var navCart = byId('navCart');
    bindOnce(navCart, 'navCart', 'click', function (e) {
      if (drawerEl()) { e.preventDefault(); openDrawer(); }
    });

    var navBurger = byId('navBurger'), navPanel = byId('navPanel');
    if (navBurger && navPanel) {                                     /* GUARD (already in v8) */
      bindOnce(navBurger, 'burger', 'click', function () {
        var open = navPanel.classList.toggle('open');
        navBurger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      bindOnce(navPanel, 'panelLinks', 'click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('a')) return;
        navPanel.classList.remove('open');
        navBurger.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /* =========================================================================
     5. slab hero: carve -> gild -> split
     ====================================================================== */
  var heroRefs = null;
  var heroMetrics = { top: 0, total: 1, ok: false };

  /* PERF FIX (a): this is the ONLY function that reads layout. It runs on
     init / load / resize / section:load — never on scroll. */
  function measureHero() {
    var hero = byId('hero');
    if (!hero) { heroMetrics.ok = false; heroRefs = null; return; }  /* GUARD */
    heroRefs = {
      hero:   hero,
      slabL:  byId('slabL'),
      slabR:  byId('slabR'),
      reveal: byId('reveal'),
      meta:   byId('slabMeta'),
      hint:   byId('scrollHint')
    };
    var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
    heroMetrics.top = hero.getBoundingClientRect().top + pageY;
    heroMetrics.total = Math.max(1, hero.offsetHeight - window.innerHeight);
    heroMetrics.ok = true;
  }

  function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function seg(t, a, b) { return Math.min(1, Math.max(0, (t - a) / (b - a))); }

  var scrollY = 0, ticking = false, lastP = -1, lastSolid = null, lastLogo = null;

  function renderScroll() {
    ticking = false;

    /* nav state — write-only, no layout reads */
    var nav = byId('nav');
    if (nav) {
      var solid = scrollY > 40;
      if (solid !== lastSolid) { nav.classList.toggle('solid', solid); lastSolid = solid; }
    }

    if (!heroMetrics.ok || !heroRefs) {
      /* pages with no slab hero: the wordmark is always visible */
      if (nav && lastLogo !== true) { nav.classList.add('logo-on'); lastLogo = true; }
      return;                                                        /* GUARD */
    }

    /* PERF FIX (b): progress is mapped DIRECTLY to scroll position.
       No lerp, no inertia — the slab stops the moment scrolling stops. */
    var p = Math.min(1, Math.max(0, (scrollY - heroMetrics.top) / heroMetrics.total));

    if (nav) {
      var logo = p > .985;
      if (logo !== lastLogo) { nav.classList.toggle('logo-on', logo); lastLogo = logo; }
    }
    if (p === lastP) return;
    lastP = p;

    /* phase 1: mark is carved into the stone · phase 2: gold leaf · phase 3: slab splits */
    var carve = seg(p, 0, .4), gild = seg(p, .3, .46), split = ease(seg(p, .46, 1));
    heroRefs.hero.style.setProperty('--carve', carve.toFixed(4));
    heroRefs.hero.style.setProperty('--gild', gild.toFixed(4));
    var shift = split * 56; /* vw */
    if (heroRefs.slabL) heroRefs.slabL.style.transform = 'translateX(' + (-shift) + 'vw)';
    if (heroRefs.slabR) heroRefs.slabR.style.transform = 'translateX(' + shift + 'vw)';
    var ro = Math.min(1, split * 1.7);
    if (heroRefs.reveal) {
      heroRefs.reveal.style.opacity = ro;
      heroRefs.reveal.style.transform = 'scale(' + (.94 + .06 * ro) + ')';
    }
    var fade = String(Math.max(0, 1 - split * 3));
    if (heroRefs.meta) heroRefs.meta.style.opacity = fade;
    if (heroRefs.hint) heroRefs.hint.style.opacity = fade;
  }

  /* PERF FIX (a): the scroll handler reads window.pageYOffset and nothing else. */
  function onScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!ticking) { ticking = true; requestAnimationFrame(renderScroll); }
  }
  function remeasure() {
    measureHero();
    lastP = -1; lastSolid = null; lastLogo = null;
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', remeasure);
  window.addEventListener('orientationchange', remeasure);
  window.addEventListener('load', remeasure);

  function openSlab() {
    if (!heroMetrics.ok) return;                                     /* GUARD */
    /* uses the cached metrics — no layout read */
    var top = heroMetrics.top + heroMetrics.total;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }
  function initHeroGestures() {
    var heroSticky = $('.hero-sticky');
    if (!heroSticky) return;                                         /* GUARD (v8 would throw here) */
    bindOnce(heroSticky, 'dbl', 'dblclick', openSlab);
    var lastTap = 0;
    bindOnce(heroSticky, 'tap', 'touchend', function () {
      var n = Date.now();
      if (n - lastTap < 320) openSlab();
      lastTap = n;
    }, { passive: true });
  }

  /* =========================================================================
     6. collection category filter
     ====================================================================== */
  function initCatFilter() {
    var catBar = byId('catBar'), collGrid = byId('collGrid');
    if (!catBar || !collGrid) return;                                /* GUARD (already in v8) */
    var catStatus = byId('catStatus');
    $$('.cat', catBar).forEach(function (x) {
      x.setAttribute('aria-pressed', x.classList.contains('on') ? 'true' : 'false');
    });
    bindOnce(catBar, 'catBar', 'click', function (e) {
      if (!e.target || !e.target.closest) return;
      var b = e.target.closest('.cat'); if (!b) return;
      $$('.cat', catBar).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
      var c = b.dataset.cat;
      collGrid.classList.toggle('filtered', c !== 'all');
      var n = 0;
      $$('.product', collGrid).forEach(function (p) {
        var show = (c === 'all' || p.dataset.cat === c);
        p.style.display = show ? '' : 'none';
        if (show) n++;
      });
      var status = byId('catStatus') || catStatus;
      if (status) {
        var sp = b.querySelector('span');
        var lbl = sp ? sp.textContent : '';
        status.textContent = 'Showing ' + n + ' ' + (n === 1 ? 'piece' : 'pieces') + (c === 'all' ? '' : ' · ' + lbl);
      }
    });
  }

  /* =========================================================================
     7. testimonials carousel
     ====================================================================== */
  var STONE_HEX={makrana:'#D8D3C8',banswara:'#C4A79F',udaipur:'#3E4A3D',bhainslana:'#1a1714',mango:'#9A6B43'};
  var STONE_FG ={makrana:'#5b554c',banswara:'#fff',udaipur:'#EDEAE3',bhainslana:'#C7A35F',mango:'#fff'};
  var TESTI=[
  {q:"Looks far more expensive than it was. Ordered online and delivered in two days — and easy to put together.",n:"Aisha Al Marri",r:"Dubai Marina",s:5,stone:'makrana'},
  {q:"Furnished my whole living room for less than one table at the mall. Great quality for the price.",n:"Omar Haddad",r:"Abu Dhabi",s:5,stone:'banswara'},
  {q:"Ordered on Sunday, at my door by Wednesday. The instructions were clear — it went together in under an hour.",n:"Priya Nair",r:"Sharjah",s:5,stone:'udaipur'},
  {q:"Modern, sturdy and didn't break the bank. Exactly what our new apartment needed.",n:"James Whitfield",r:"Dubai",s:5,stone:'mango'},
];
  function testiData() {
    var t = window.ZOVA_TESTIMONIALS;
    return (t && t.length) ? t : TESTI;      /* Liquid override, else original */
  }
  var ti = 0;
  function initials(n) {
    return String(n || '').split(' ').filter(Boolean).map(function (w) { return w[0]; }).slice(0, 2).join('').toUpperCase();
  }
  function renderTesti() {
    var list = testiData();
    var tPhoto = byId('tPhoto'), tQuote = byId('tQuote'), tAuthor = byId('tAuthor'),
        tRole = byId('tRole'), tStars = byId('tStars'), tThumbs = byId('testiThumbs');
    if (!list.length) return;                                        /* GUARD */
    if (ti >= list.length || ti < 0) ti = 0;
    var t = list[ti];
    if (tPhoto) {
      tPhoto.style.background = STONE_HEX[t.stone] || '';
      tPhoto.style.color = STONE_FG[t.stone] || '';
      tPhoto.textContent = initials(t.n);
    }
    if (tQuote)  tQuote.textContent = t.q;
    if (tAuthor) tAuthor.textContent = t.n;
    if (tRole)   tRole.textContent = t.r;
    if (tStars) {
      var s = Math.max(0, Math.min(5, t.s || 0));
      tStars.setAttribute('role', 'img');
      tStars.setAttribute('aria-label', s + ' out of 5 stars');
      tStars.innerHTML = '<span aria-hidden="true">' + '★★★★★'.slice(0, s) + '☆☆☆☆☆'.slice(0, 5 - s) + '</span>';
    }
    // side thumbs: the next two upcoming
    if (tThumbs) {
      tThumbs.innerHTML = '';
      [1, 2].forEach(function (off) {
        var idx = (ti + off) % list.length, tt = list[idx];
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'tthumb';
        d.style.background = STONE_HEX[tt.stone] || '';
        d.style.color = STONE_FG[tt.stone] || '';
        d.textContent = initials(tt.n);
        d.setAttribute('aria-label', 'Show testimonial ' + (idx + 1) + ' of ' + list.length + ' from ' + tt.n);
        d.addEventListener('click', function () { ti = idx; renderTesti(); });
        tThumbs.appendChild(d);
      });
    }
  }
  function initTesti() {
    var next = byId('tNext'), prev = byId('tPrev');
    if (!next && !prev && !byId('tQuote')) return;                   /* GUARD (v8 threw here off-homepage) */
    bindOnce(next, 'tNext', 'click', function () { var l = testiData(); ti = (ti + 1) % l.length; renderTesti(); });
    bindOnce(prev, 'tPrev', 'click', function () { var l = testiData(); ti = (ti - 1 + l.length) % l.length; renderTesti(); });
    renderTesti();
  }

  /* =========================================================================
     8. lightweight 3D pointer tilt (GPU, no libraries)
     ====================================================================== */
  function initTilt() {
    var fine = !!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);
    if (!fine || reduce) return;
    var els = $$('[data-tilt]');
    $$('.product .canvas').forEach(function (c) {
      if (!c.hasAttribute('data-tilt')) { c.setAttribute('data-tilt', '5'); els.push(c); }
    });
    els.forEach(function (el) {
      if (el.__zovaTilt) return;                                     /* GUARD: never double-bind */
      el.__zovaTilt = true;
      var max = parseFloat(el.dataset.tilt) || 6; var rx = 0, ry = 0, raf = null;
      var apply = function () {
        el.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        raf = null;
      };
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * max * 2;
        rx = -((e.clientY - r.top) / r.height - 0.5) * max * 2;
        el.style.transition = 'none';
        if (!raf) raf = requestAnimationFrame(apply);
      });
      el.addEventListener('pointerleave', function () {
        rx = ry = 0; el.style.transition = 'transform .45s ease';
        if (!raf) raf = requestAnimationFrame(apply);
      });
    });
  }

  /* =========================================================================
     9. product data (Liquid may override via window.ZOVA_PRODUCTS/CATMETA)
     ====================================================================== */
  var CDN_DEFAULT='https://cdn.shopify.com/s/files/1/0765/0656/2752/files/';
  var ZP_DEFAULT={"verona": {"name": "Verona Nesting Tables · Set of 3", "cat": "nesting", "price": "749", "was": "899", "sku": "VE-NST-CHTBLK", "blurb": "A set of three nesting tables in warm chestnut-finish mango wood on slim black metal frames. Nest them to save space or spread them out when guests arrive — modern, practical, and at home in any living room.", "hi": ["Set of 3 — nest or spread out", "Mango wood tops + black metal", "Lightweight, easy to rearrange"], "specs": [["Sizes", "S 34×51×26 · M 40×56×28 · L 46×61×30 cm"], ["Top", "Solid mango wood"], ["Frame", "Metal"], ["Weight", "9 kg"], ["Set", "3 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required (not included)"]], "imgs": ["VEFUR-NSCH-1-1.png?v=1781249531", "VEFUR-NSCH-1-2.png?v=1781249612", "VEFUR-NSCH-1-6.png?v=1781249634", "VEFUR-NSCH-1-3.png?v=1781249633", "VEFUR-NSCH-1-5.png?v=1781249635", "VEFUR-NSCH-1-4.png?v=1781249634"], "variants": []}, "medici": {"name": "Medici Marble Coffee Table", "cat": "coffee", "price": "990", "was": "1,190", "sku": "VE-OVCT-GLDWHT", "blurb": "An oval coffee table with a veined marble top and sleek gold-finish metal legs. The soft oval shape keeps your living room feeling open, and the top wipes clean in seconds.", "hi": ["Oval marble top", "Gold-finish metal legs", "Wipe-clean & heat-resistant"], "specs": [["Size", "89 × 45 × 40 cm"], ["Top", "Marble"], ["Legs", "Metal"], ["Shape", "Oval"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["029-WHTGLD-1.jpg?v=1782299278", "029-WHTGLD-2.jpg?v=1782299291", "029-WHTGLD-3.jpg?v=1782299297", "029-WHTGLD-4.jpg?v=1782299302"], "variants": []}, "milano": {"name": "Milano Bar Stool", "cat": "stool", "price": "349", "was": "429", "sku": "CF3317WT-CHETBK", "blurb": "A height-adjustable, swivel bar stool with a chestnut-finish wooden seat and a sturdy black metal frame. Perfect for a kitchen island or a home bar — comfortable, good-looking, built to last.", "hi": ["Height-adjustable & swivels", "Solid chestnut wood seat", "Sturdy metal frame"], "specs": [["Size", "55 × 72 × 42 cm"], ["Weight", "7 kg"], ["Seat", "Solid wood"], ["Frame", "Metal"], ["Feature", "Adjustable height"], ["Set", "1 piece"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["LovetoBarstool.png?v=1781252147"], "variants": []}, "carrara": {"name": "Carrara Marble Side Tables · Set of 2", "cat": "side", "price": "799", "was": "949", "sku": "VE-NSTRND-GRYWHT", "blurb": "Two round side tables with grey-and-white veined marble tops on slim metal legs. Use them beside the sofa or bed, together or apart — an easy way to add a polished surface to any room.", "hi": ["Set of 2 round tables", "Grey & white marble", "Sofa-side or bedside"], "specs": [["Sizes", "40×54×40 · 35×40×35 cm"], ["Top", "Marble"], ["Legs", "Metal"], ["Shape", "Round"], ["Set", "2 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["026-MWHTGRY-1.png?v=1782298778", "026-MWHTGRY-2.png?v=1782298810", "026-MWHTGRY-3.png?v=1782298826", "026-MWHTGRY-4.png?v=1782298877", "026-MWHTGRY-5.png?v=1782298886", "026-MWHTGRY6.png?v=1782298889"], "variants": []}, "como": {"name": "Como Nesting Coffee Table · Set of 2", "cat": "coffee", "price": "1,090", "was": "", "sku": "004-CHETBK", "blurb": "A sculptural pair of round nesting coffee tables — chestnut-toned wood tops on slim black metal frames. Slide one under the other to save space, or split them across the room. Industrial edge, natural warmth.", "hi": ["Set of 2 round tables", "Chestnut wood + black metal", "Space-saving nesting design"], "specs": [["Top", "Chestnut-finish wood"], ["Frame", "Black powder-coated metal"], ["Shape", "Round"], ["Set", "2 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"]], "imgs": ["004-CHETBK-3.png?v=1781884662", "004-CHETBK-1.png?v=1781884662", "004-CHETBK-2.jpg?v=1781884600", "004-CHETBK-4.png?v=1781884661", "004-CHETBK-5.png?v=1781884663"], "variants": []}, "aurelia": {"name": "Aurelia Marble Nesting Tables · Set of 2", "cat": "nesting", "price": "849", "was": "999", "sku": "VE-NSTRND-GLDWHT", "blurb": "Two round marble nesting tables with gold-finish metal legs. The veined tops add a little polish to a living room or bedside, and they're light enough to move wherever the room needs a surface.", "hi": ["Set of 2 round tables", "Marble tops, gold legs", "Side or bedside use"], "specs": [["Sizes", "L 40×40×54.5 · S 35×35×50 cm"], ["Top", "Marble"], ["Legs", "Metal"], ["Shape", "Round"], ["Set", "2 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["VEFUR-NSGM-6-1.jpg?v=1782299128", "VEFUR-NSGM-6-2.jpg?v=1782299144", "VEFUR-NSGM-6-3.jpg?v=1782299149"], "variants": []}, "siena": {"name": "Siena Nesting Tables · Set of 3", "cat": "nesting", "price": "699", "was": "849", "sku": "VE-NST", "blurb": "A versatile set of three nesting tables on metal frames, in your choice of finish. Stack them away or fan them out for extra surfaces whenever you need them — equally at home in modern or classic rooms.", "hi": ["Set of 3 — choose your finish", "Warm Oak or Natural & Black", "Solid wood tops, metal frames"], "specs": [["Sizes", "45×59×30 · 40×54×25 · 35×50×20 cm"], ["Top", "Solid mango wood"], ["Frame", "Metal"], ["Set", "3 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["VEFUR-NSCH-1-1_0eaebcde-d09f-4392-b1bd-11f8395ca26f.png?v=1782299419", "VEFUR-NSCH-1-2_a1a66e17-7b74-4a3d-8ca1-b459db847af0.png?v=1782299443", "VEFUR-NSCH-1-3_1cee8b4b-7cf0-43dc-96c6-1b37f88d9ff7.png?v=1782299448", "VEFUR-NSCH-1-4_9bf58fd3-b9af-4cb2-b4ed-96381d0acd9e.png?v=1782299452", "VEFUR-NSCH-1-5_05a2104e-2c46-402b-bce5-e2cfece5f4e9.png?v=1782299458", "VEFUR-NSCH-1-6_376a1569-03d2-4a64-9a67-df070d13565e.png?v=1782299462"], "variants": [["Warm Oak Antique", "699", "849"], ["Natural & Black", "699", "849"]]}, "toscana": {"name": "Toscana Nesting Coffee Table · Set of 2", "cat": "coffee", "price": "1,090", "was": "1,290", "sku": "VE-NSTRD-BLKCHT", "blurb": "Two round nesting coffee tables in warm wood and black metal. Use them together for a layered look or pull them apart to serve the whole room — rustic warmth meets clean modern lines.", "hi": ["Set of 2 round tables", "Solid wood tops + metal", "Use together or apart"], "specs": [["Sizes", "L 80×42×80 · S 50×38×50 cm"], ["Top", "Solid wood"], ["Legs", "Metal"], ["Shape", "Round"], ["Set", "2 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["167650595-1.png?v=1782299000", "167650595-2.png?v=1782299025", "167650595-3.png?v=1782299032", "167650595-4.png?v=1782299035"], "variants": []}, "eclisse": {"name": "Eclisse Side Tables · Set of 2", "cat": "side", "price": "699", "was": "849", "sku": "VE-NSTM-BLK", "blurb": "A set of two all-black metal side tables with clean, modern lines. Two graduated sizes let you nest them, pair them, or place them apart — a sleek perch for drinks, books, or decor.", "hi": ["Set of 2, two sizes", "Sleek all-metal build", "Nest, pair, or split"], "specs": [["Sizes", "35×55×38 · 30×53×33 cm"], ["Top & legs", "Metal, black finish"], ["Set", "2 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["021-METBLK-1.jpg?v=1782298292", "021-METBLK-2.jpg?v=1782298307", "021-METBLK-3.jpg?v=1782298313"], "variants": []}, "verde": {"name": "Verde Marble Nesting Tables · Set of 2", "cat": "nesting", "price": "799", "was": "949", "sku": "VE-NSTRND-GRYGRN", "blurb": "A pair of round nesting tables with grey-green veined marble tops on slim metal legs. A subtle pop of colour and a hard-wearing surface for drinks, books, or decor.", "hi": ["Set of 2 round tables", "Grey-green marble tops", "Slim metal legs"], "specs": [["Sizes", "40×55×40 · 35×50×35 cm"], ["Top", "Marble"], ["Legs", "Metal"], ["Shape", "Round"], ["Set", "2 pieces"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["026-MGRNBLK-1.png?v=1782298463", "026-MGRNBLK-2.png?v=1782298487", "026-MGRNBLK-3.png?v=1782298496", "026-MGRNBLK-4.png?v=1782298500", "026-MGRNBLK-5.png?v=1782298511"], "variants": []}, "bellini": {"name": "Bellini Bar & Serving Trolley", "cat": "serving", "price": "749", "was": "899", "sku": "VE-TROLLY-BLK", "blurb": "A sleek black metal serving trolley on wheels — plenty of room for drinks, glassware and snacks, and light enough to roll from kitchen to lounge. A practical bar cart that doubles as a statement piece.", "hi": ["Rolls on wheels", "Two-tier metal frame", "No assembly needed"], "specs": [["Size", "40 × 40 × 75 cm"], ["Material", "Metal"], ["Wheels", "Yes"], ["Set", "1 piece"], ["Care", "Wipe clean"], ["Warranty", "5 years"], ["Assembly", "Not required — ships built"]], "imgs": ["020-METBLK-1.jpg?v=1782297904", "020-METBLK-2.jpg?v=1782297927", "020-METBLK-3.jpg?v=1782297941"], "variants": []}, "davinci": {"name": "Da Vinci Home Office Desk", "cat": "desk", "price": "1,290", "was": "1,590", "sku": "VE-AERST-GLD", "blurb": "A modern home-office desk with a geometric gold metal frame and glass tiers — a sturdy workspace plus vertical shelving for books and decor. Open and airy, so it works even in smaller rooms.", "hi": ["Glass-tier hutch storage", "Gold geometric frame", "Great for small spaces"], "specs": [["Size", "95 × 62 × 200 cm"], ["Frame", "Metal"], ["Tiers", "Glass"], ["Type", "Desk with hutch"], ["Warranty", "5 years"], ["Assembly", "Required"]], "imgs": ["VE-ARDSK-GLD-1.png?v=1782298129", "VE-ARDSK-GLD-2.png?v=1782298149", "VE-ARDSK-GLD-3.png?v=1782298157", "VE-ARDSK-GLD-5.png?v=1782298162", "VE-ARDSK-GLD-6.png?v=1782298171"], "variants": []}};
  var CATMETA_DEFAULT={"coffee": ["Coffee Tables", "Marble, wood and glass centrepieces for the living room.", 3], "side": ["Side Tables", "Sofa-side and bedside tables, sold as handy sets of two.", 2], "nesting": ["Nesting Tables", "Stackable sets that flex with your space.", 4], "stool": ["Bar Stools", "Adjustable, swivelling seating for islands and home bars.", 1], "serving": ["Serving & Bar", "Roll-around trolleys for drinks and entertaining.", 1], "desk": ["Desks", "Compact home-office desks with smart storage.", 1]};
  var CDN = (typeof window.ZOVA_CDN === 'string' && window.ZOVA_CDN) ? window.ZOVA_CDN : CDN_DEFAULT;

  /* sections/card-collection.liquid emits window.ZOVA_PRODUCTS with one entry per
     card that has a real Shopify product attached — real title, price, images and,
     crucially, real variant ids. Entries are MERGED over the demo data above per
     data-id, so a card with no product keeps its static copy. Read late (like
     testiData) so a section re-render in the theme editor is picked up. */
  function productData(id) {
    var over = window.ZOVA_PRODUCTS;
    if (over && typeof over === 'object' && over[id]) return over[id];
    return ZP_DEFAULT[id];
  }
  function catMeta() {
    var over = window.ZOVA_CATMETA;
    return (over && typeof over === 'object') ? over : CATMETA_DEFAULT;
  }

  /* absolute urls from Liquid pass through untouched; bare filenames get the CDN prefix */
  function imgUrl(u, w) {
    var src = String(u || '');
    if (!/^(https?:)?\/\//.test(src)) src = CDN + src;
    /* Liquid-emitted urls already carry a width= param — retarget it, never stack a second one */
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* =========================================================================
     10. quick view
     ====================================================================== */
  var qvVarIdx = 0;
  function el(id) { return document.getElementById(id); }

  function variantIdFor(p) {
    if (!p) return '';
    var v = p.variants && p.variants[qvVarIdx];
    if (v && v[3]) return v[3];                     /* [label, price, was, variantId] */
    return p.variantId || p.variant_id || '';
  }

  function openQV(id) {
    var qv = byId('qvOverlay'); if (!qv) return;                     /* GUARD */
    var p = productData(id); if (!p) return; qvVarIdx = 0;
    var n, cm = catMeta();
    if ((n = el('qvCat')))   n.textContent = (cm[p.cat] ? cm[p.cat][0] : '');
    if ((n = el('qvName')))  n.textContent = p.name;
    if ((n = el('qvBlurb'))) n.textContent = p.blurb;
    // gallery
    var main = el('qvMain'), thumbs = el('qvThumbs');
    if (p.imgs && p.imgs.length) {
      var setMain = function (u) {
        if (main) main.innerHTML = '<img src="' + imgUrl(u, 900) + '" alt="' + esc(p.name) + '">';
      };
      setMain(p.imgs[0]);
      if (thumbs) {
        thumbs.innerHTML = '';
        p.imgs.forEach(function (u, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'qv-thumb' + (i === 0 ? ' on' : '');
          b.innerHTML = '<img src="' + imgUrl(u, 200) + '" alt="" loading="lazy">';
          b.addEventListener('click', function () {
            setMain(u);
            $$('.qv-thumb', thumbs).forEach(function (x) { x.classList.remove('on'); });
            b.classList.add('on');
          });
          thumbs.appendChild(b);
        });
        thumbs.style.display = p.imgs.length > 1 ? '' : 'none';
      }
    } else {
      var cardCanvas = $('.product[data-id="' + id + '"] .canvas');
      if (main) {
        main.innerHTML = '<div class="qv-render">' + (cardCanvas ? cardCanvas.innerHTML.replace(/<span class="qv-badge">.*?<\/span>/, '') : '') + '</div>';
        $$('[data-stone]', main).forEach(paintStone);
      }
      if (thumbs) { thumbs.innerHTML = ''; thumbs.style.display = 'none'; }
    }
    // highlights
    if ((n = el('qvHi'))) n.innerHTML = (p.hi || []).map(function (h) { return '<li>' + h + '</li>'; }).join('');
    // variants
    var vbox = el('qvVar');
    if (vbox) {
      if (p.variants && p.variants.length) {
        vbox.style.display = '';
        vbox.innerHTML = '<span class="qv-vlabel">Finish</span><div class="qv-vopts">' +
          p.variants.map(function (v, i) {
            return '<button type="button" class="qv-vopt' + (i === 0 ? ' on' : '') + '" data-i="' + i + '">' + v[0] + '</button>';
          }).join('') + '</div>';
        $$('.qv-vopt', vbox).forEach(function (b) {
          b.addEventListener('click', function () {
            qvVarIdx = +b.dataset.i;
            $$('.qv-vopt', vbox).forEach(function (x) { x.classList.remove('on'); });
            b.classList.add('on');
            renderQVPrice(p);
            syncQVAdd(p);
          });
        });
      } else { vbox.style.display = 'none'; vbox.innerHTML = ''; }
    }
    renderQVPrice(p);
    syncQVAdd(p);
    // specs
    if ((n = el('qvSpecs'))) {
      n.innerHTML = '<h4>Details</h4><dl>' + (p.specs || []).map(function (sp) {
        return '<div><dt>' + sp[0] + '</dt><dd>' + sp[1] + '</dd></div>';
      }).join('') + '</dl>';
    }
    if ((n = el('qvSku'))) n.textContent = p.sku ? 'SKU: ' + p.sku : '';
    qv.hidden = false; lockScroll();
    var close = el('qvClose'); if (close && close.focus) { try { close.focus(); } catch (e) {} }
  }

  function renderQVPrice(p) {
    var node = el('qvPrice'); if (!node || !p) return;                /* GUARD */
    var price = p.price, was = p.was;
    if (p.variants && p.variants[qvVarIdx]) { price = p.variants[qvVarIdx][1]; was = p.variants[qvVarIdx][2]; }
    node.innerHTML = 'AED ' + price + (was ? ' <span class="qv-was">AED ' + was + '</span>' : '');
  }
  function syncQVAdd(p) {
    var add = el('qvAdd'); if (!add) return;
    var vid = variantIdFor(p);
    if (vid) add.setAttribute('data-variant-id', vid); else add.removeAttribute('data-variant-id');
    /* fallback target when the entry carries no variant id (static demo copy) */
    if (p && p.url) add.setAttribute('data-product-url', p.url); else add.removeAttribute('data-product-url');
  }
  function closeQV() {
    var qv = byId('qvOverlay'); if (!qv || qv.hidden) return;         /* GUARD */
    qv.hidden = true; unlockScroll();
  }

  function initQV() {
    var qv = byId('qvOverlay');
    if (qv) {
      bindOnce(el('qvClose'), 'qvClose', 'click', closeQV);
      bindOnce(qv, 'qvBackdrop', 'click', function (e) { if (e.target === qv) closeQV(); });
      bindOnce(el('qvAdd'), 'qvAdd', 'click', function () {
        var add = el('qvAdd');
        var vid = add ? add.getAttribute('data-variant-id') : '';
        if (vid) { closeQV(); addToCart(vid, 1); return; }
        /* no variant id: send the shopper to the product page if we know it,
           otherwise say so — never fake a cart add. */
        var url = add ? add.getAttribute('data-product-url') : '';
        if (url) { window.location.href = url; return; }
        closeQV();
        showCartError(UNAVAILABLE);
      });
    }
    // card -> quick view (but not the Add button)
    var collGrid = byId('collGrid');
    if (collGrid) {                                                  /* GUARD (v8 threw here off-homepage) */
      bindOnce(collGrid, 'qvOpen', 'click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('.cart-btn')) return;
        var a = e.target.closest('.product');
        if (a && a.dataset.id) openQV(a.dataset.id);
      });
      bindOnce(collGrid, 'qvKeys', 'keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('product')) {
          e.preventDefault(); openQV(e.target.dataset.id);
        }
      });
    }
  }

  /* Escape closes the quick view, then the drawer */
  bindOnce(document, 'escKey', 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    var qv = byId('qvOverlay');
    if (qv && !qv.hidden) { closeQV(); return; }
    var d = drawerEl();
    if (d && d.classList.contains('is-open')) closeDrawer();
  });

  /* =========================================================================
     11. shop by category
     ====================================================================== */
  function initCatGrid() {
    var catGrid = byId('catGrid');
    if (!catGrid) return;                                            /* GUARD (already in v8) */
    bindOnce(catGrid, 'catGrid', 'click', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target.closest('[data-go]'); if (!t) return;
      var c = t.dataset.go;
      var btn = $$('.cat').filter(function (x) { return x.dataset.cat === c; })[0];
      if (btn) btn.click();
      var target = byId('collection');
      if (target && target.scrollIntoView) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      else if (!target) window.location.href = '/collections/all';    /* GUARD: inner pages */
    });
  }

  /* =========================================================================
     12. category icons
     ====================================================================== */
  var CATICONS={
 coffee:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><ellipse cx="24" cy="17" rx="16" ry="5"/><path d="M12 19v17M36 19v17M18 21v13M30 21v13"/></svg>',
 side:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="13" y="13" width="22" height="5" rx="1"/><path d="M16 18v18M32 18v18"/></svg>',
 nesting:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="7" y="15" width="17" height="4" rx="1"/><path d="M9 19v15M22 19v15"/><rect x="24" y="21" width="15" height="4" rx="1"/><path d="M26 25v11M37 25v11"/></svg>',
 stool:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 15h16l-2 6H18z"/><path d="M19 21 16 39M29 21l3 18M17 31h14"/></svg>',
 serving:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 11h24M12 27h24M14 11v22M34 11v22"/><circle cx="16" cy="37" r="2.4"/><circle cx="32" cy="37" r="2.4"/></svg>',
 desk:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 31h30M11 31V17h26v14M15 31v7M33 31v7"/><rect x="17" y="20" width="14" height="6" rx="1"/></svg>'
};
  function initCatIcons(root) {
    $$('[data-cat-vis]', root).forEach(function (v) { v.innerHTML = CATICONS[v.dataset.catVis] || ''; });
  }

  /* =========================================================================
     13. newsletter
     ====================================================================== */
  function initNewsletter() {
    var newsForm = byId('newsForm');
    if (!newsForm) return;                                           /* GUARD (v8 threw here off-homepage) */
    bindOnce(newsForm, 'news', 'submit', function (e) {
      /* If Liquid rendered a real {% form 'customer' %} (it has an action),
         let Shopify handle the POST. Otherwise keep the v8 demo response. */
      var action = newsForm.getAttribute('action');
      if (action) return;
      e.preventDefault();
      var ok = byId('newsOk');
      if (ok) ok.textContent = 'Thank you — you’re on the list for new arrivals & offers.';
      var input = newsForm.querySelector('input');
      if (input) input.value = '';
    });
  }

  /* =========================================================================
     14. boot
     ====================================================================== */
  function init(root) {
    paintAllStones(root);
    initNav();
    initHeroGestures();
    initCatFilter();
    initTesti();
    initTilt();
    initQV();
    initCatGrid();
    initCatIcons(root);
    initNewsletter();
    remeasure();
  }

  /* ------------------------------------------------------------------
     Broken-image fallback.
     The demo product imagery is hot-linked from an external Shopify CDN
     that this store does not own, so any of those files can be deleted
     without warning (one already has been). A dead <img> would otherwise
     render as a browser "broken image" icon inside the product frame.
     Instead, flag the frame so CSS can show a neutral stone-toned panel
     with the product name, keeping the grid intact. Uses a capture-phase
     listener because 'error' does not bubble.
     ------------------------------------------------------------------ */
  document.addEventListener('error', function (e) {
    var img = e && e.target;
    if (!img || img.tagName !== 'IMG' || img.dataset.fallbackApplied) return;
    img.dataset.fallbackApplied = '1';
    var frame = img.closest('.canvas, .spot-canvas, .qv-main, .drawer-item .canvas');
    if (!frame) return;
    frame.classList.add('img-missing');
    if (!frame.querySelector('.img-missing-label')) {
      var span = document.createElement('span');
      span.className = 'img-missing-label';
      span.textContent = img.getAttribute('alt') || '';
      frame.appendChild(span);
    }
    img.style.display = 'none';
  }, true);

  function boot() {
    init(document);
    refreshCart();                 /* real Shopify item_count on load */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor: sections are re-rendered in place */
  document.addEventListener('shopify:section:load', function (e) {
    init((e && e.target) || document);
  });
  document.addEventListener('shopify:section:unload', function () { remeasure(); });
  document.addEventListener('shopify:section:reorder', function () { remeasure(); });

})();
